import React, { createContext, useEffect, useState } from "react";
import { default as config } from "../constants/config.json";

import "semantic-ui-css/semantic.min.css";
import "../styles/index.scss";
import "../styles/ui.grid.css";
import "./Layout.css";

import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { details } from "../crud/user";
import { storeGet, storeSet } from "../crud/storage";
import { useHistory, useLocation } from "react-router-dom";

export const UserContext = createContext(null);

/**
 * NLayout — pure context provider. No layout chrome.
 * Provides: UserContext (userData + userActions), GA tracking, toast container.
 * Layout chrome (Header/Footer vs Sidebar/MobileNav) is handled by Routes.js.
 */
function Layout({ children }) {
  const history = useHistory();
  const location = useLocation();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    window.gtag("config", config.GoogleAnalytics.code, {
      page_path: window.location.hash,
    });
  }, [location]);

  const _userDetails = () => {
    details()
      .then((response) => {
        setUserData(response.data.success);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          storeSet("user", null);
        } else {
          if (error.response && error.response.data && error.response.data.message) {
            toast({
              type: "error",
              title: error.response.data.message,
              animation: "bounce",
              time: 5000,
            });
          }
        }
      });
  };

  useEffect(() => {
    const userStorage = storeGet("user");
    if (userStorage && userStorage.token) {
      _userDetails();
    }
  }, [location]);

  const userActions = {
    openUserModal: () => {
      history.push("/login");
    },
    logout: () => {
      storeSet("user", null);
      setUserData(null);
      history.push("/");
    },
  };

  return (
    <UserContext.Provider value={{ userData, userActions }}>
      {children}
      <SemanticToastContainer position="bottom-right" />
    </UserContext.Provider>
  );
}

export default Layout;
